export const AVAILABILITY_NOT_BETWEEN_BOOKING_HOURS_ERROR = 'AvailabilityNotBetweenBookingHoursError';
export const AVAILABILITY_HOLIDAY_ERROR = 'AvailabilityHolidayError';
export const AVAILABILITY_OVERLAP_ERROR = 'AvailabilityOverlapError';
export const AVAILABILITY_IN_THE_PAST_ERROR = 'AvailabilityInThePastError';
export const AVAILABILITY_BEYOND_MAX_DAYS_IN_ADVANCE_ERROR = 'AvailabilityBeyondMaxDaysInAdvanceError';